module.exports = __webpack_public_path__ + "static/media/check-list.b712fda4.png";